import * as actions from "./actionsTypes";

const initialData = {
  loadingEmployeeValue: false,
  loadingEmployeeValueById: false,
  saveLoadingEmployeeValue: false,
  employeeValuesLength: 0,
  employeeValues: [],
  employeeValue: {},
  employeeValueError: "",
  formErrorEmployeeValue: "",

  loadingBossValue: false,
  loadingBossValueById: false,
  saveLoadingBossValue: false,
  bossValuesLength: 0,
  bossValues: [],
  bossValue: {},
  bossValueError: "",
  formErrorBossValue: "",
};

export default function EvaluationValueReducer(state = initialData,action) {
  switch (action.type) {

    //valores del empleado
    case actions.LOADING_EMPLOYEE_VALUE:
      return { ...state, loadingEmployeeValue: action.payload };
    case actions.LOADING_EMPLOYEE_VALUE_BY_ID:
      return { ...state, loadingEmployeeValueById: action.payload };
    case actions.SAVE_LOADING_EMPLOYEE_VALUE:
      return { ...state, saveLoadingEmployeeValue: action.payload };
    case actions.GET_EMPLOYEE_VALUE:
      return {
        ...state,
        employeeValues: action.payload.employeeValues,
        employeeValuesLength: action.payload.employeeValuesLength,
      };
    case actions.GET_EMPLOYEE_VALUE_BY_ID:
      return {
        ...state, employeeValue: action.payload
      };
    case actions.FORM_FAIL_EMPLOYEE_VALUE:
      return { ...state, formErrorEmployeeValue: action.payload };
    case actions.EMPLOYEE_VALUE_FAIL:
      return { ...state, employeeValueError: action.payload };

      

    //valores del jefe
    case actions.LOADING_BOSS_VALUE:
      return { ...state, loadingBossValue: action.payload };
    case actions.LOADING_BOSS_VALUE_BY_ID:
      return { ...state, loadingBossValueById: action.payload };
    case actions.SAVE_LOADING_BOSS_VALUE:
      return { ...state, saveLoadingBossValue: action.payload };
    case actions.GET_BOSS_VALUE:
      return {
        ...state,
        bossValues: action.payload.bossValues,
        bossValuesLength: action.payload.bossValuesLength,
      };
    case actions.GET_BOSS_VALUE_BY_ID:
      return {
        ...state, bossValue: action.payload
      };
    case actions.FORM_FAIL_BOSS_VALUE:
      return { ...state, formErrorBossValue: action.payload };
    case actions.BOSS_VALUE_FAIL:
      return { ...state, bossValueError: action.payload };
    default:
      return state;
  }
}
